import { GwDatesWrapper } from '../../../components/_internal_date_/gwDatesWrapper';
import { addOnsMapperNewAPIToOldApi } from '../../../pages/ReservationDetail/utils';
import { getTheFirstElementOfArray } from '../../../utilities/arraysUtils';

export const getManageReservationDetails = state => state?.manageReservationDetails;

export const getCanCancel = state => state?.data?.canCancel;

export const getCanAddGuests = state => state?.data?.canAddGuests;

export const getProduct = state => state?.data?.product;

export const getGuests = state => state?.data?.guests;

export const getOfferCode = state => state?.data?.offerCode;

export const getArrival = state => state?.data?.arrival;

export const getIsLoading = state => state?.isLoading;

export const getDeparture = state => state?.data?.departure;

export const getReservationId = state => state?.data?.id;

export const getResortFee = state => state?.data?.costSummary?.taxesAndFees?.RESORT;

export const getTotal = state => state?.data?.costSummary?.total;

export const getIsReservationOnlyToken = state => state?.data?.isReservationOnlyToken;

export const getCheckIn = state => state?.data?.checkIn;

export const getUpsellAddOns = state => {
  const arrivalDate = state.reservationDetails?.data?.arrival ?? state.manageReservationDetails?.data?.arrival;
  const departureDate = state.reservationDetails?.data?.departure ?? state.manageReservationDetails?.data?.departure;
  const today = GwDatesWrapper.today();
  const isDateOfReservation =
    GwDatesWrapper.isBetween(today, arrivalDate, departureDate) ||
    GwDatesWrapper.isSame(today, arrivalDate) ||
    GwDatesWrapper.isSame(today, departureDate);

  const upsellAddOns = state.manageReservationDetails.data?.upsellAddOns ?? [];

  if (isDateOfReservation) {
    return upsellAddOns.filter(tile => tile.type === 'cabana');
  }

  return upsellAddOns;
};

export const getComparison = state => {
  return state?.data?.comparisonChanges;
};

export const getComparisonContactInfo = state => state?.data?.comparisonChanges?.contactInfo;
export const getComparisonPaymentInfo = state => state?.data?.comparisonChanges?.payment;

export const getAddGuestReservationObj = state => {
  return state?.addGuestsReservationObj;
};

export const getChangeFee = state => state?.data?.costSummary?.taxesAndFees?.RESERVATION_CHANGE_FEE;

export const getNewReservationHasAvailabilityKey = state =>
  Boolean(state?.data?.comparisonChanges?.new?.availabilityKey);

export const getUpsellAddOnByType = (state, packageType) => {
  const upsellAddOns = state.manageReservationDetails.data?.upsellAddOns ?? [];
  const cardTile = upsellAddOns.filter(pck => pck.type?.includes(packageType));
  const addOnsWithContent = cardTile[0]?.addOns
    ? addOnsMapperNewAPIToOldApi(getTheFirstElementOfArray(cardTile)?.addOns, packageType)
    : [];
  return addOnsWithContent;
};
